export default {
    idleTimeOutHeader: {
        id: `MEDCAL_RX_IDLE_TIMEOUT_HEADER`,
        defaultMessage: 'You Have Been Idle!',
    },
    idleTimeOutText: {
        id: `MEDCAL_RX_IDLE_TIMEOUT_TEXT`,
        defaultMessage: 'Your session will be terminated due to inactivity.',
    },
    idleTimeOutLogout: {
        id: `MEDCAL_RX_IDLE_TIMEOUT_LOGOUT`,
        defaultMessage: 'Logout',
    },
    idleTimeLeft: {
        id: `MEDCAL_RX_IDLE_TIME_LEFT`,
        getText: (time) => `You will be logged out in ${time} seconds.`,
    },
    idleTimeOutStay: {
        id: `MEDCAL_RX_IDLE_TIMEOUT_STAY`,
        defaultMessage: 'Stay',
    }
};
